import React from 'react';
import NoteBox from '../components/NoteBox';

const STAGES: { key: string; title: string; accent: string; placeholder: string }[] = [
  {
    key: 'prospects:new-leads',
    title: 'New Leads',
    accent: '#2563EB',
    placeholder: 'Fresh leads — name, source, quick context…',
  },
  {
    key: 'prospects:contacted',
    title: 'Contacted',
    accent: '#7C3AED',
    placeholder: 'Reached out — when, channel, response so far…',
  },
  {
    key: 'prospects:proposal-in-progress',
    title: 'Proposal in Progress',
    accent: '#D97706',
    placeholder: 'Actively drafting — scope, budget, blockers…',
  },
  {
    key: 'prospects:proposal-sent',
    title: 'Proposal Sent / Follow-up',
    accent: '#16A34A',
    placeholder: 'Sent — date, next follow-up, status…',
  },
];

export default function ProspectsPage() {
  return (
    <div style={{ padding: 32, maxWidth: 960, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.3px' }}>
          Prospects
        </h1>
        <p style={{ color: '#64748B', fontSize: 14, marginTop: 4 }}>
          Track prospective clients through the sales pipeline
        </p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {STAGES.map((s) => (
          <NoteBox
            key={s.key}
            noteKey={s.key}
            title={s.title}
            accent={s.accent}
            placeholder={s.placeholder}
            minHeight={140}
          />
        ))}
      </div>
    </div>
  );
}
